import React, { useEffect } from 'react';
import "./informacion.css";
import { informacion } from '../../json/informacion';

const Informacion = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className='container container-mh'>
            <div className='row'>
                <div className='col-12'>
                    <h2>Acerca de la Información y Comunicación de la SECTURH</h2>
                    <ul className='informacion'>
                        {informacion.map((item, index) => (
                            <li key={index}>{item.funcion}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Informacion